import React from 'react';
import { WordRotate } from '@/components/word-rotate';
import { Loader } from 'lucide-react';

function PollingUi() {
  return (
    <div className='fixed top-0 left-0 bottom-0 right-0 bg-brand-third bg-opacity-50 flex justify-center items-center backdrop-blur-sm z-50 max-h-screen no-doc-scroll'>
      <div className='flex flex-col justify-center items-center'>
        <WordRotate
          className='text-4xl lg:text-5xl font-bold text-white dark:text-white'
          words={[
            'Secure Payment',
            'Learn Anytime',
            'Instant Access',
            'Gain Skills',
            'Career Boost',
            'Start Today',
            'Upgrade Knowledge',
            'Full Support',
            'Expert Guidance',
            'Course Certified',
          ]}
        />
        <div className='flex flex-col justify-center items-center mt-5'>
          <Loader className='animate-spin' />
          <p className='text-sm animate-pulse text-center'>
            Please don't refresh or close this window <br />
            your payment is being processed.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PollingUi;
